import React, { useRef, useState, useId } from "react";
import './MyAccountReviews.scss';
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function MyAccountReviews({ }) {
    const navigate = useNavigate();
    const location = useLocation()
    const url = new URL(window.location.href);
    let arr = Array.apply(null, { length: 10 }).map(Number.call, Number);

    useEffect(() => {
        // window.scrollBy({
        //     top: 330,
        //     behavior: 'smooth'
        //   });
    }, []);

    return (
        <div className="MyAccountReviews">
            <div className="MyAccountReviewsHeader">
                <div className="MyAccountReviewsHeaderLeft">
                    <h1>My Reviews</h1>
                    <h2>Reviews from Your Recent HandyBy Projects</h2>
                </div>
                <img src={require(`../../../Images/verify.png`)} alt="Chimney Cleaning" />
            </div>
            <div className="MyAccountReviewsList">
                <table className="MyAccountReviewsListMTable">
                    <tr>
                        <th>Category</th>
                        <th>Project ID</th>
                        <th>Date Created</th>
                        <th>Stars</th>
                        <th>Status</th>
                    </tr>
                    <tr>
                        <td><h2>Air Duct</h2></td>
                        <td><h1>Project: #74239494</h1></td>
                        <td><h3>03 Jul 25</h3></td>
                        <td>
                            <h3>
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                            </h3>
                        </td>
                        <td><h1>Pending</h1></td>
                    </tr>
                    <tr>
                        <td><h2>Air Duct</h2></td>
                        <td><h1>Project: #74239494</h1></td>
                        <td><h3>03 Jul 25</h3></td>
                        <td>
                            <h3>
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                            </h3>
                        </td>
                        <td><h1>Pending</h1></td>
                    </tr>
                    <tr>
                        <td><h2>Air Duct</h2></td>
                        <td><h1>Project: #74239494</h1></td>
                        <td><h3>03 Jul 25</h3></td>
                        <td>
                            <h3>
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                            </h3>
                        </td>
                        <td><h1>Pending</h1></td>
                    </tr>
                    <tr>
                        <td><h2>Air Duct</h2></td>
                        <td><h1>Project: #74239494</h1></td>
                        <td><h3>03 Jul 25</h3></td>
                        <td>
                            <h3>
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                            </h3>
                        </td>
                        <td><h1>Pending</h1></td>
                    </tr>
                    <tr>
                        <td><h2>Air Duct</h2></td>
                        <td><h1>Project: #74239494</h1></td>
                        <td><h3>03 Jul 25</h3></td>
                        <td>
                            <h3>
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                            </h3>
                        </td>
                        <td><h1>Pending</h1></td>
                    </tr>
                    <tr>
                        <td><h2>Air Duct</h2></td>
                        <td><h1>Project: #74239494</h1></td>
                        <td><h3>03 Jul 25</h3></td>
                        <td>
                            <h3>
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                                <img className="HomePageTopBannerImg" src={require(`../../../Images/star.png`)} />
                            </h3>
                        </td>
                        <td><h1>Pending</h1></td>
                    </tr>
                </table>
            </div>
            <div className="NotificationMenu" style={{ "backgroundColor": "#ecf4ff", "border": "1px solid #5797ff" }}>
                <img src={require(`../../../Images/n-info.png`)} />
                <span>
                    <h1>We Keep Reviews Honest</h1>
                    <p>Companies on HandyBy can’t offer incentives or pay to hide any reviews.</p>
                </span>
            </div>
        </div >
    )
}

